import { render, staticRenderFns } from "./AddBestellung.vue?vue&type=template&id=6d286486&scoped=true&"
import script from "./AddBestellung.vue?vue&type=script&lang=js&"
export * from "./AddBestellung.vue?vue&type=script&lang=js&"
import style0 from "./AddBestellung.vue?vue&type=style&index=0&id=6d286486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d286486",
  null
  
)

export default component.exports